import React from "react";
import { contentTypes } from "../../../../data/categories";

/**
 * @param {{ active: string, onChange: (f: string) => void }} props
 */
function PipelineFilters({ active, onChange }) {
  const filters = React.useMemo(() => ["All", ...contentTypes], []);

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex-1 min-w-0">
        <div
          className="flex flex-nowrap gap-2 overflow-x-auto whitespace-nowrap px-1 -mx-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          aria-label="Pipeline filters"
        >
          {filters.map((label) => {
          const isOn = active === label;
          return (
            <button
              key={label}
              type="button"
              onClick={() => onChange(label)}
              className={`px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
                isOn
                  ? "border-orange-500 text-orange-600 bg-orange-50"
                  : "border-gray-200 text-gray-600 bg-white hover:border-gray-300"
              }`}
            >
              {label}
            </button>
          );
        })}
        </div>
      </div>
      {/* <p className="text-xs text-gray-400 whitespace-nowrap sm:text-right">
        Drag cards — or use stage buttons
      </p> */}
    </div>
  );
}

export default PipelineFilters;
